import { NgModule } from '@angular/core';

import { StudentsRoutingModule } from './students-routing.module';
import { StudentProgramsComponent } from './student-programs/student-programs.component';
import { ProgramsModule } from '../programs/programs.module';
import { StudentService } from './shared/student.service';
import { CoreModule } from '../../core/core.module';
import { StudentComponent } from './student/student.component';
import { StudentRequestComponent } from './student-request/student-request.component';
import { HistoryComponent } from './history/history.component';
import { HistoryStudentDialogComponent } from '../../core/modal/history-student-dialog/history-student-dialog.component';


@NgModule({
  imports: [
    CoreModule,
    ProgramsModule,
    StudentsRoutingModule,
  ],
  declarations: [StudentProgramsComponent, StudentComponent, StudentRequestComponent, HistoryComponent,
    HistoryStudentDialogComponent],
  exports: [StudentProgramsComponent, StudentComponent, StudentsRoutingModule, StudentRequestComponent, HistoryComponent,
    HistoryStudentDialogComponent ],
  providers: [StudentService],
  entryComponents: [HistoryStudentDialogComponent]
})
export class StudentsModule { }
